import { compose } from 'redux';
import { connect } from '../../../../../common/react-redux';
import { fromJS } from 'immutable';
import { showError } from '../../../../../common/actions/errorsShowing';
import { openModal, openMoveImmutableModal } from '../../../../../common/actions/modal';
import { screenreaderNotification } from '../../../../../common/actions/alerts';
import { set, newActiveBank, newActiveBankEntry } from '../../../../../common/actions/ui';
import { newHoverPosition } from '../../../../../common/actions/dragAndDrop';
import { changeQuizEntryPoints, moveTemporaryQuizEntry } from '../../../../../common/actions/modifications';
import makeEditable from '../../../../../common/components/shared/functionality/makeEditable';
import { moveQuizEntry } from '../../../../api/quizEntries';
import { featureOn } from '../../../../../common/util/featureCheck';
import { DropTargetCreator } from '../../../../../common/components/shared/drag_and_drop/dragAndDropUtils';
import { QuizEntry as QuizEntryPresenter } from './presenter';
import { SHOULD_CLONE_ITEM, QUIZ_ENTRY_GUID_SUFFIX, QUIZ_ENTRY_REF } from '@instructure/quiz-common';
import { getActiveQuiz } from '../../../../../common/selectors/quizzes';
import quizEntryPresenterWrapper from './quizEntryPresenterWrapper';
export var mapStateToProps = function mapStateToProps(state, props) {
  var activeQuiz = getActiveQuiz(state);
  var quizId = activeQuiz.id;
  var guid = "".concat(props.quizEntry.id, "_").concat(QUIZ_ENTRY_GUID_SUFFIX);
  var dndPosition = state.getIn(['dragAndDrop', 'position']);
  var draggingOver = dndPosition === props.quizEntry.position;
  var dndData = draggingOver ? state.get('dragAndDrop') : null;
  var initialFocusId = state.getIn(['editing', 'initialFocusId']);
  var entry = props.quizEntry.isBankEntry ? props.quizEntry.getEntry().getEntry() : props.quizEntry.getEntry();
  var useBankTags = featureOn('item_bank_tagging');
  var tagAssociations = null;
  if (useBankTags && props.quizEntry.isBankEntry) {
    var topEntry = props.quizEntry.getEntry();
    var entryType = topEntry.get('entryType');
    var entryId = entry.get('id');
    tagAssociations = fromJS(state.getIn(['tagAssociations', entryType, entryId]));
  }
  return {
    entry: entry,
    dndPositionObj: dndData,
    // needed for DnD
    guid: guid,
    initialFocusId: initialFocusId,
    partialDeepScoringEnabled: featureOn('partial_deep_scoring'),
    partialScoringEnabled: featureOn('partial_scoring'),
    quizId: quizId,
    // needed for DND
    regradingOn: featureOn('regrading'),
    shouldClone: state.getIn(['ui', SHOULD_CLONE_ITEM]),
    tagAssociations: tagAssociations,
    useBankTags: useBankTags,
    workingEntry: entry.getWorkingInstance(),
    workingQuizEntry: props.quizEntry.getWorkingInstance()
  };
};
var dispatchToProps = {
  changeQuizEntryPoints: changeQuizEntryPoints,
  openModal: openModal,
  openMoveImmutableModal: openMoveImmutableModal,
  moveQuizEntry: moveQuizEntry,
  // needed for DnD
  moveTemporaryQuizEntry: moveTemporaryQuizEntry,
  // needed for DnD
  newActiveBank: newActiveBank,
  newActiveBankEntry: newActiveBankEntry,
  newHoverPosition: newHoverPosition,
  // needed for DnD
  screenreaderNotification: screenreaderNotification,
  setUi: set,
  showError: showError
};
export var QuizEntry = compose(connect(mapStateToProps, dispatchToProps), makeEditable, DropTargetCreator(QUIZ_ENTRY_REF))(quizEntryPresenterWrapper(QuizEntryPresenter));
export default QuizEntry;